// extracted by mini-css-extract-plugin
export default {"default":"Subject_default__Gbuap","fade-out":"Subject_fade-out__HKDkE","chosen":"Subject_chosen__1wq1T","fade-in":"Subject_fade-in__50P8Q"};